import values from 'lodash/values';

export const isBooleanGroup = (schemaNode = {}, cb = () => true) => {
  if (schemaNode.properties && Object.keys(schemaNode.properties).length > 1) {
    return values(schemaNode.properties).every(
      ({ type, ...rest }) => type === 'boolean' && cb(rest)
    );
  }

  return false;
};

export const isCheckboxGroup = schemaNode =>
  isBooleanGroup(
    schemaNode,
    (node = {}) => node['$customInput'] === 'Checkbox'
  );
